import { displayDigits } from '../utils/displayDigits';
import React from 'react';
import { useLocale } from '../hooks/useLocale';
import { ActionIconButton } from './ui/ActionButton';
import { ActionSymbol } from './ui/ActionSymbol';
import { IoArrowBackOutline } from 'react-icons/io5';

interface NmSectionHeaderProps {
  title: string;
  /** Optional compact count shown beside the title (e.g. athlete roster size). */
  count?: number | null;
  actionLabel?: string;
  /** `add` shows +; `back` shows a directional arrow for navigate-back screens. */
  actionVariant?: 'add' | 'back';
  onAction?: () => void;
  className?: string;
}

/** Section title row with optional count badge and add/back action — VO2 DS. */
export function NmSectionHeader({
  title,
  count,
  actionLabel,
  actionVariant = 'add',
  onAction,
  className = '',
}: NmSectionHeaderProps) {
  const { isRtl } = useLocale();

  return (
    <div className={`nm-section-header ${className}`.trim()}>
      <h2 className="nm-section-title">
        <span className="nm-section-title__label">{title}</span>
        {count != null && (
          <span className="nm-section-title__count" aria-label={displayDigits(count)}>
            {displayDigits(count)}
          </span>
        )}
      </h2>
      {onAction && (
        <ActionIconButton
          type="button"
          variant={actionVariant === 'add' ? 'primary' : 'neutral'}
          className={
            actionVariant === 'add'
              ? 'nm-section-header__action nm-section-header__action--add'
              : 'nm-section-header__action'
          }
          label={actionLabel ?? title}
          onClick={onAction}
          icon={actionVariant === 'back'
            ? <IoArrowBackOutline aria-hidden="true" style={{ transform: isRtl ? 'rotate(180deg)' : undefined }} />
            : <ActionSymbol name="add" />}
        />
      )}
    </div>
  );
}
